import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import FormPage from "ui/FormPage";
import { PrimaryButton, OutlineButton } from "ui/Buttons";
import FormTextField from "ui/FormTextField";

import { createReconocimiento } from "../services/reconocimientos";

// Extrae mensajes legibles de distintos formatos de error del backend
function extractErrMessages(err) {
  const out = [];
  const push = (m) => { if (m) out.push(String(m)); };

  const d = err?.response?.data ?? err;

  if (typeof d === "string") {
    push(d);
  } else if (Array.isArray(d)) {
    d.forEach((it) => push(it?.message || JSON.stringify(it)));
  } else if (d?.errors && Array.isArray(d.errors)) {
    d.errors.forEach((it) => push(it?.message || `${it?.instancePath || it?.path || ""} ${it?.message || ""}`.trim()));
  } else if (d?.message) {
    push(d.message);
  } else {
    push(err?.message || "Error desconocido");
  }
  return out;
}

export default function NuevoReconocimiento() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [groupId, setGroupId] = useState(""); // opcional
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const groupIdNum = Number(groupId);
  const isGroupValid = !groupId || (Number.isFinite(groupIdNum) && groupIdNum > 0);
  const isValid = useMemo(() => !!name.trim() && isGroupValid, [name, isGroupValid]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;
    setSaving(true);
    setErrors([]);
    try {
      const payload = { name: name.trim(), ...(groupId ? { group_id: groupIdNum } : {}) };
      await createReconocimiento(payload);
      navigate("/catalogos/reconocimientos", { replace: true });
    } catch (e) {
      setErrors(extractErrMessages(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      title="Nuevo reconocimiento"
      onBack={() => navigate("/catalogos/reconocimientos")}
      pageMaxWidth={1100}
      contentMaxWidth={900}
      actions={
        <>
          <PrimaryButton type="submit" form="form-rec" disabled={!isValid || saving}>
            {saving ? "Guardando..." : "Guardar"}
          </PrimaryButton>
          <OutlineButton onClick={() => navigate("/catalogos/reconocimientos")}>
            Cancelar
          </OutlineButton>
        </>
      }
    >
      {errors.length > 0 && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errors.map((m, i) => <div key={i}>{m}</div>)}
        </Alert>
      )}

      <form id="form-rec" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormTextField
              label="Nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormTextField
              label="Group ID"
              type="number"
              value={groupId}
              onChange={(e) => setGroupId(e.target.value)}
              helperText={isGroupValid ? "" : "Debe ser un número mayor a 0"}
              error={!isGroupValid}
              required
            />
          </Grid>
        </Grid>
      </form>
    </FormPage>
  );
}